import { Request } from "../../infrastructure/request";
import { Response } from "../../infrastructure/response";

export interface ICacheProvider {
	set(key: string, data: object, ttl): Promise<void>;
	has(key: string): Promise<boolean>;
	get(key: string): Promise<object>;
}
